import React, { Fragment, useState } from 'react'
import { Modal } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import urlImageMFV from "../../../assets/img/logo.png"

const no_op = () => { };
const AboutModal = ({ openModal = false, setOpenModal = no_op }) => {
    //const url_image = `${process.env.REACT_APP_PUBLIC_URL}clinica/${getIdClinica()}/logo/${getToken()}`;
	//const urlImageSAC = "https://www.gamanuclear.com/imagen/logo-medical-mfv.png"
    //const urlImageSAC = process.env.REACT_APP_PUBLIC_URL + "clinica/3/logo-medical-team-sac-2.png" + sessionStorage.getItem('token')
   // const clinica = JSON.parse()
    return (
        <Modal
            open={openModal}
            onClose={() => {
                setOpenModal();
            }}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            style={{ zIndex: 1000 }}
        >
            <div className="paperAppointment-flex-about-modal">
                <IconButton style={{ float: 'right' }} onClick={() => {
                    setOpenModal();
                }}>
                    <CloseIcon />
                </IconButton>
                <div>
                    <img src={urlImageMFV} style={{ objectFit: 'contain', height: '200px' }} /> 
                    {/* <img alt="logo"
                                        style={{ objectFit: 'contain', height: '100%' }}
                                        src={process.env.REACT_APP_PUBLIC_URL + "clinica/" + dataInvoice.clinica?.id_clinica + "/logo/" + sessionStorage.getItem('token')} /> */}
                </div>
                <div className='container-about-page'>
                    <h4 className='title-about'>KOMPATECH</h4>
                    <p className='content-about'>Version: 1</p>
                    <h6 className='title-about'>KOMPATECH esta desarrollado en:</h6>
                    <p className='content-about'>React.JS | Node.JS</p>
                    <h6 className='title-about'>Base de datos:</h6>
                    <p className='content-about'>PostgresSQL</p>
                </div>
            </div>
        </Modal>
    )
}
export default AboutModal